module.exports = __webpack_public_path__ + "img/logo@2x.1472b6a5.png";